import Swiper, { Navigation } from "swiper";
import ProtoScroll from "../modules/proto-scroll";

const SinglePortfolio = {
  init() {
    ProtoScroll.init();
    this.events();
    this.protoSwiper();
    this.protoLaptopSwiper();
    this.related();
  },

  events() {
    $(".proto-nav__item").on("click", (e) => {
      // Set active class for item
      $(".proto-nav__item").removeClass("active");
      $(e.currentTarget).addClass("active");

      // Change active proto preview
      const target = $(e.currentTarget).data("target");

      $(".proto").removeClass("active");
      $(`[data-id=${target}]`).addClass("active");
    });
  },

  protoSwiper() {
    // Mobile proto swiper
    const protoMobileEl = $(".proto--mobile");
    if (!protoMobileEl.length) {
      return;
    }

    if (protoMobileEl.length) {
      const navPrev = protoMobileEl.find(".swiper-button--prev");
      const navNext = protoMobileEl.find(".swiper-button--next");

      new Swiper(protoMobileEl.find(".swiper")[0], {
        spaceBetween: 50,
        breakpoints: {
          786: {
            slidesPerView: 2,
          },
          1100: {
            slidesPerView: 3,
          },
        },
        modules: [Navigation],
        navigation: {
          prevEl: navPrev[0],
          nextEl: navNext[0],
        },
      });
    }

    // Laptop proto swiper
    // const protoLaptopEl = $(".proto--laptop");
    // if (!protoLaptopEl.length) {
    //   return;
    // }

    // if (protoLaptopEl.length) {
    //   const navPrev = protoLaptopEl.find(".swiper-button--prev");
    //   const navNext = protoLaptopEl.find(".swiper-button--next");

    //   new Swiper(protoLaptopEl.find(".swiper")[0], {
    //     slidesPerView: 1,
    //     modules: [Navigation],
    //     navigation: {
    //       prevEl: navPrev[0],
    //       nextEl: navNext[0],
    //     },
    //   });
    // }
  },

  protoLaptopSwiper() {
    const protoLaptopEl = $(".proto--laptop");
    if (!protoLaptopEl.length) {
      return;
    }
    const navPrev = protoLaptopEl.find(".swiper-button--prev");
    const navNext = protoLaptopEl.find(".swiper-button--next");

    new Swiper(protoLaptopEl.find(".swiper")[0], {
      slidesPerView: 1,
      modules: [Navigation],
      navigation: {
        prevEl: navPrev[0],
        nextEl: navNext[0],
      },
    });
  },

  related() {
    const relatedSwiper = $(".portfolio-related");
    if (!relatedSwiper.length) {
      return;
    }

    const navPrev = relatedSwiper.find(".swiper-button--prev");
    const navNext = relatedSwiper.find(".swiper-button--next");

    new Swiper(relatedSwiper.find(".portfolio-related__slider")[0], {
      slidesPerView: 2,
      spaceBetween: 160,
      modules: [Navigation],
      navigation: {
        prevEl: navPrev[0],
        nextEl: navNext[0],
      },
      breakpoints: {
        0: {
          slidesPerView: 1.5,
          spaceBetween: 30,
        },
        600: {
          slidesPerView: 1.5,
          spaceBetween: 80,
        },
        1100: {
          slidesPerView: 2,
          spaceBetween: 80,
        },
        1400: {
          spaceBetween: 160,
        },
      },
    });
  },
};

export default SinglePortfolio;
